import { __decorate } from '../../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../../node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { ifDefined as l } from '../../../../../node_modules/lit-html/directives/if-defined.js';
import css_248z from './footer-nav-item.scss.js';

class FooterNavItem extends s {
    constructor() {
        super(...arguments);
        this.href = '#';
        this.label = '';
        this.ariaText = null;
        this.additionalClass = '';
        this.title = '';
    }
    isCookiePreferencesLink() {
        return this.additionalClass
            .split(' ')
            .map(cssClass => cssClass.trim())
            .includes('optanon-toggle-display');
    }
    static openCookiePreferences() {
        const oneTrust = window === null || window === void 0 ? void 0 : window.OneTrust;
        if (typeof (oneTrust === null || oneTrust === void 0 ? void 0 : oneTrust.ToggleInfoDisplay) === 'function') {
            oneTrust.ToggleInfoDisplay();
            return;
        }
        if (typeof (oneTrust === null || oneTrust === void 0 ? void 0 : oneTrust.ShowPreferenceCenter) === 'function') {
            oneTrust.ShowPreferenceCenter();
            return;
        }
        const fallbackButton = document.querySelector('#onetrust-pc-btn-handler, .ot-sdk-show-settings');
        fallbackButton === null || fallbackButton === void 0 ? void 0 : fallbackButton.click();
    }
    handleClick(event) {
        if (!this.isCookiePreferencesLink()) {
            return;
        }
        event.preventDefault();
        event.stopPropagation();
        FooterNavItem.openCookiePreferences();
    }
    render() {
        const ariaLabel = this.ariaText && this.ariaText.trim() !== '' ? this.ariaText : undefined;
        const classNames = this.additionalClass
            ? `footer-nav-item__link ${this.additionalClass}`
            : 'footer-nav-item__link';
        return $ `<a class="${classNames}" href="${this.href}" @click="${this.handleClick}" aria-label="${l(ariaLabel)}" title="${l(this.title || undefined)}"><span class="footer-nav-item__text">${this.label}</span><span class="footer-nav-item__chevron" aria-hidden="true"><span class="material-symbols-outlined">chevron_right</span></span></a>`;
    }
}
FooterNavItem.styles = css_248z;
__decorate([
    e({ type: String })
], FooterNavItem.prototype, "href", void 0);
__decorate([
    e({ type: String })
], FooterNavItem.prototype, "label", void 0);
__decorate([
    e({ type: String })
], FooterNavItem.prototype, "ariaText", void 0);
__decorate([
    e({ type: String })
], FooterNavItem.prototype, "additionalClass", void 0);
__decorate([
    e({ type: String })
], FooterNavItem.prototype, "title", void 0);
customElements.define('footer-nav-item', FooterNavItem);

export { FooterNavItem };
